export default __webpack_public_path__ + "static/media/PATCHWORK CLOTH.19b5220e.jpg";